
import LinkAngled from "../../../assets/outline/LinkAngled.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LinkAngledIcon({ className, dataTestid = "LinkAngledIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LinkAngled data-testid={dataTestid} className={classes} {...rest} />
  );
}
